// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"488":"0c31691c","826":"da5c090b","931":"e8b53bfa","990":"10922519"}[chunkId] + ".chunk.js");